module.exports = __webpack_public_path__ + "img/admins.62629b6b.svg";